import { LightShadow } from '../../thirdparty/three/imports';

export class LightShadow3D
{
    declare _shadow: LightShadow;

    get mapSize()
    {
        return this._shadow.mapSize;
    }
    set mapSize(v)
    {
        this._shadow.mapSize = v;
    }

    get bias()
    {
        return this._shadow.bias;
    }
    set bias(v)
    {
        this._shadow.bias = v;
    }

    get normalBias()
    {
        return this._shadow.normalBias;
    }
    set normalBias(v)
    {
        this._shadow.normalBias = v;
    }
}
